export const FEE_TYPE = [
  {
    id: 'ANNUALISED_FEE_ACT_360_DEDUCTED_AT_MATURITY',
    displayValue: 'Annualised Fee Act 360 Deducted At Maturity',
  },
  { id: 'BID_OFFER_SPREAD', displayValue: 'Bid Offer Spread' },
  { id: 'CUSTODIAN_FEE', displayValue: 'Custodian Fee' },
  { id: 'DISCOUNT_FEE', displayValue: 'Discount Fee' },
  { id: 'DISTRIBUTION_FEE', displayValue: 'Distribution Fee' },
  { id: 'LISTING_FEE', displayValue: 'Listing Fee' },
  { id: 'INTERMEDIARY_FEE', displayValue: 'Intermediary Fee' },
  { id: 'INTRODUCTORY_FEE', displayValue: 'Introductory Fee' },
  { id: 'RUNNING_FEE', displayValue: 'Running Fee' },
  { id: 'STRUCTURING_FEE', displayValue: 'Structuring Fee' },
  { id: 'UPFRONT_FEE', displayValue: 'Upfront Fee' },
  { id: 'ENTRY_COSTS', displayValue: 'Entry Costs' },
];
